import { ITeamRole } from "models/IProjectIQWorkspace";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { selectAvailableProjectIqWorkspaces } from "redux/projectIqWorkspacesSlice";

const QUALITY_REVIEW_ROLE_NAMES = ["Client Lead", "Engagement Leader"];

export const useQualityReviewAccess = (workspaceId: string): boolean => {
  const workspaces = useSelector(selectAvailableProjectIqWorkspaces);
  const workspace = workspaces.find(
    (candidateWorkspace) => candidateWorkspace.id === workspaceId,
  );
  const currentUser = useSelector(
    (state: RootState) => state.currentUserSlice.value,
  );

  const currentUserDisplayName = currentUser?.displayName?.trim().toLowerCase();
  if (!currentUserDisplayName) return false;

  const teamRoles: ITeamRole[] = workspace?.people?.teamRoles ?? [];
  return teamRoles
    .filter((role) => QUALITY_REVIEW_ROLE_NAMES.includes(role.name))
    .some(
      (role) =>
        role.assignedMember?.trim().toLowerCase() === currentUserDisplayName,
    );
};
